<template>
  <div class="loading-cargo-info" @click="proceedLoading(cargo)">
    <div class="row loading-cargo-info">
      <div class="col-11 loading-info-left">
        <div class="row">
          <div class="col-12">
            <p class="truck-info">{{ cargo.reference }}</p>
          </div>
        </div>
        <div class="row status-time">
          <div class="col-5 status" >
            <overview-status :finished="cargo.finished" :status="cargo.status"/>
          </div>
          <div class="col-5 estimated-time">
            <p class="etd"><i class="far fa-clock"/> {{ formatETD(cargo.estimatedTimeOfDeparture) }} </p>
          </div>
          <div class="col-2 extra-info">
            <div class="deviation-present-container" v-if="getDeviationsOfCargo(cargo.cargoId, ['PRESENT_ON_FLOOR']).length">
              <transition name="fade" appear>
                <i @click="showDeviations($event)" class="fas fa-exclamation-triangle deviation-present"/>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <div class="col-1 arrow">
        <i class="fas fa-chevron-right"/>
      </div>
      <opened-users :loaded="getLoadedUsers(cargo.id)" :opened="getOpenUsersList"
                    v-if="(getAPICompanyID === 7 || getAPICompanyID === 1)"/>
    </div>
    <div v-if="(getAPICompanyID === 7 || getAPICompanyID === 1)" class="row loading-cargo-info cargo-progress">
      <progress-bar-cargo :cargo="cargo" :progressOutgoing="getProgressOfCargo(cargo.id).progress"/>
    </div>
  </div>

</template>


<script>
import overviewStatus from './OverviewStatus';
import {mapGetters} from "vuex";
import ProgressBarCargo from "@/components/ProgressBarCargo";
import OpenedUsers from "@/components/loading/OpenedUsers"
import {openCargo, getOpenUsers} from "@/mixins/openCargo";
import {deviationPopUp} from "@/mixins/deviationPopUp";


export default {
  name: 'loaded-Cargo',
  props: ['cargo'],
  mixins: [openCargo, deviationPopUp],
  components: {
    OpenedUsers,
    ProgressBarCargo,
    overviewStatus
  },
  methods: {
    formatETD(dateFromFirebase) {
      return moment(dateFromFirebase.toDate()).format('DD/MM HH:mm')
    },
    showDeviations(event) {
      // Dont open
      event.stopPropagation();
      const deviations = this.getDeviationsOfCargo(this.cargo.cargoId, ['PRESENT_ON_FLOOR']);
      this.showDeviationSwal(deviations);
    },
    proceedLoading(cargo) {
      this.openCargo(cargo.id);
      if (cargo.status == undefined) {
        let etd = this.formatTime(cargo.estimatedTimeOfDeparture);
        this.$swal({
          title: this.$root.$t('cargo.startLoading.title'),
          html: '<strong>' + this.$root.$t('cargo.startLoading.reference') + '</strong>  ' + cargo.reference + ' <br><strong>' + this.$root.$t('cargo.startLoading.etd') + '</strong> ' + etd,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$root.$t('button.start'),
          cancelButtonText: this.$root.$t('button.cancel'),
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.$router.push({name: 'loading-cargo-orders', params: {id: cargo.id}});
          }
        });
      } else {
        this.$router.push({name: 'loading-cargo-orders', params: {id: cargo.id}});
      }
    },
    formatTime(time) {
      if (time) {
        return moment(time.toDate()).format('HH:mm');
      }
    }
  },
  created() {
    this.$store.dispatch('initDataForPage', [{module: 'deviations', where: ['cargoId', '==', this.cargo.cargoId]}]);
  },
  computed: {
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('deviations', ['getDeviationsOfCargo']),
    ...mapGetters('outgoingCargoProgress', ['getProgressOfCargo']),
    ...mapGetters('orders', ['getOrderIdsFromCargo']),
    getOpenUsersList() {
      return this.getOpenUsers(this.cargo.id);
    }
  }
};
</script>

<style scoped lang="scss">
.orderStatsPicking {
  font-size: 20px;
}

.cargo-progress {
  background-color: inherit;
}

</style>
